var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9349 11.318L14.7683 4.17221C14.3284 3.78733 13.6716 3.78732 13.2318 4.17221L5.0651 11.318C4.81191 11.5396 4.66669 11.8596 4.66669 12.196V22.1667C4.66669 22.811 5.18902 23.3333 5.83335 23.3333H10.5C11.1444 23.3333 11.6667 22.811 11.6667 22.1667V17.5C11.6667 16.8557 12.189 16.3333 12.8334 16.3333H15.1667C15.811 16.3333 16.3334 16.8557 16.3334 17.5V22.1667C16.3334 22.811 16.8557 23.3333 17.5 23.3333H22.1667C22.811 23.3333 23.3334 22.811 23.3334 22.1667V12.196C23.3334 11.8596 23.1881 11.5396 22.9349 11.318Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.18d5af48b30c5f6bf33b562a7af8c79f.svg";
export { ForwardRef as ReactComponent };